function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.2.69453125c.7651441 0 1.4.6348559 1.4 1.4v9.79999995c0 .765144-.6348559 1.4000001-1.4 1.4000001h-3.5205079l-1.3794921 1.4054687-1.3794921-1.4054687h-3.5205079c-.76514396 0-1.4-.6348561-1.4-1.4000001v-9.79999995c0-.7651441.63485604-1.4 1.4-1.4zm0 1.40546875h-9.8v9.8h4.1083987l.7916013.8066407.7916013-.8066407h4.1083987zm-8.4 1.5v1.4h1.4v-1.4zm2.8 0v1.4h4.2v-1.4zm-2.8 2.8v1.4h1.4v-1.4zm2.8 0v1.4h4.2v-1.4zm-2.8 2.8v1.4h1.4v-1.4zm2.8 0v1.4h4.2v-1.4z",
  fill: "#3bace0"
});

var SvgDetails = function SvgDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 13 15",
    width: 13,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/details.2d7de539.svg";
export { ForwardRef as ReactComponent };